
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"27","viewBox":"0 0 18 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.74219 20.6523H12.8164C13.2148 20.6523 13.4844 20.3828 13.4844 19.9961V18.25C13.4844 15.5664 17.3867 13.8555 17.3867 9.02734C17.3867 3.92969 13.9414 0.519531 8.78516 0.519531C3.62891 0.519531 0.171875 3.92969 0.171875 9.02734C0.171875 13.8555 4.08594 15.5664 4.08594 18.25V19.9961C4.08594 20.3828 4.34375 20.6523 4.74219 20.6523ZM5.11719 23.6641H12.4414C13.0156 23.6641 13.4844 23.1953 13.4844 22.6094C13.4844 22.0234 13.0156 21.5547 12.4414 21.5547H5.11719C4.54297 21.5547 4.07422 22.0234 4.07422 22.6094C4.07422 23.1953 4.54297 23.6641 5.11719 23.6641ZM8.78516 26.3828C10.3438 26.3828 11.4453 25.6562 11.5625 24.5664H6.00781C6.10156 25.6562 7.20312 26.3828 8.78516 26.3828Z","fill":"currentColor"}})])
          )
        }
      }
    